import { render, staticRenderFns } from "./SysConfigList.vue?vue&type=template&id=3c83a900&scoped=true&"
import script from "./SysConfigList.vue?vue&type=script&lang=js&"
export * from "./SysConfigList.vue?vue&type=script&lang=js&"
import style0 from "./SysConfigList.vue?vue&type=style&index=0&id=3c83a900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83a900",
  null
  
)

export default component.exports